/* Aviso entre pantallas cuando cambian los datos del usuario: el perfil lo
   lanza al guardar y la barra lateral lo escucha para refrescar el saludo sin
   recargar la pagina. */
export const USER_UPDATED_EVENT = 'tp:user-updated';

export const notifyUserUpdated = (changes) => {
  window.dispatchEvent(new CustomEvent(USER_UPDATED_EVENT, { detail: changes || {} }));
};

export const onUserUpdated = (handler) => {
  window.addEventListener(USER_UPDATED_EVENT, handler);
  return () => window.removeEventListener(USER_UPDATED_EVENT, handler);
};
